import React from 'react'
import { Route } from 'react-router-dom'
import { AuditLogRoute } from '../../../../shared/audit/audit-log/audit-log-route'

// /org/audit-log: the organization's Audit log; /org/audit-log/entry/:entryID
// opens one entry's permalink over it.
export const LayoutOrgAuditLog = () =>
  <Route path="/org/audit-log/:entry(entry)?/:entryID?" exact>
    <AuditLogRoute base="/org/audit-log" home="/org/dashboard" />
  </Route>
